import { geoAlbersUsa, geoPath } from 'd3-geo';
import { feature } from 'topojson-client';
import statesTopo from 'us-atlas/states-10m.json';

// A real US map, projected once at module load into a fixed viewBox.
export const MAP_W = 900;
export const MAP_H = 520;

const US_STATES_FC = feature(statesTopo, statesTopo.objects.states);
export const US_PROJECTION = geoAlbersUsa().fitSize([MAP_W, MAP_H], US_STATES_FC);
const US_PATH_GEN = geoPath(US_PROJECTION);

// thin out vertices (~14k → ~3.6k) so the map is cheap to paint
const thinRing = (ring, step) => {
  if (ring.length <= 12) return ring;
  const out = [];
  for (let i = 0; i < ring.length - 1; i += step) out.push(ring[i]);
  out.push(ring[0]);
  return out;
};
const thinGeometry = (geom, step) => {
  if (geom.type === 'Polygon') {
    return { ...geom, coordinates: geom.coordinates.map((r) => thinRing(r, step)) };
  }
  if (geom.type === 'MultiPolygon') {
    return {
      ...geom,
      coordinates: geom.coordinates.map((poly) => poly.map((r) => thinRing(r, step))),
    };
  }
  return geom;
};
export const US_STATE_PATHS = US_STATES_FC.features.map((f) =>
  US_PATH_GEN({ ...f, geometry: thinGeometry(f.geometry, 4) })
);

export const HUB = US_PROJECTION([-95, 39]);
const arcPath = (a, b, lift) => {
  const mx = (a[0] + b[0]) / 2;
  const my = (a[1] + b[1]) / 2 - lift;
  return `M${a[0]} ${a[1]} Q${mx} ${my} ${b[0]} ${b[1]}`;
};
export const SHIP_ROUTES = [
  { name: 'New York', city: [-74.0, 40.71], color: '#01a7ff', lift: 70 },
  { name: 'Los Angeles', city: [-118.24, 34.05], color: '#10b981', lift: 70 },
  { name: 'Miami', city: [-80.19, 25.76], color: '#f59e0b', lift: 35 },
  { name: 'Seattle', city: [-122.33, 47.6], color: '#f43f5e', lift: 80 },
].map((r) => {
  const end = US_PROJECTION(r.city);
  return { ...r, end, d: arcPath(HUB, end, r.lift) };
});

// A projected point as CSS percentages of the map box.
export const pct = ([x, y]) => ({ left: `${(x / MAP_W) * 100}%`, top: `${(y / MAP_H) * 100}%` });
